export const AI_SUGGESTION_MODAL_QUERY_PARAM = 'showAISuggestionModal';
